import { Dispatch, SetStateAction } from 'react';
import {
  ChildCareAgeGroups,
  SEOChildCareQualifications,
  SEOSegmentationFilterInput,
} from '@/__generated__/globalTypes';
import { NumberOfChildren } from './NumberOfChildren';
import { PayRate } from '../../PayRate';
import { ChildAgeRanges } from './ChildAgeRanges';
import { ProfessionalSkills } from './ProfessionalSkills';
import { Preferences } from '../../Preferences';
import { LanguagesSpoken } from '../../LanguagesSpoken';

type PreferencesType = Pick<
  SEOSegmentationFilterInput,
  'comfortableWithPets' | 'hasCar' | 'nonSmoker'
>;

interface ChildCareFiltersProp {
  hourlyRate: [number, number];
  setHourlyRate: Dispatch<SetStateAction<[number, number]>>;
  numberOfChildren: number;
  setNumberOfChildren: Dispatch<SetStateAction<number>>;
  childCareAgeGroupsList: ChildCareAgeGroups[];
  setChildCareAgeGroupsList: Dispatch<SetStateAction<ChildCareAgeGroups[]>>;
  childCareProfessionalSkillsList: SEOChildCareQualifications[];
  setChildCareProfessionalSkillsList: Dispatch<SetStateAction<SEOChildCareQualifications[]>>;
  setPreferencesObject: Dispatch<SetStateAction<PreferencesType>>;
  languagesSpoken: SEOSegmentationFilterInput['languages'];
  setLanguagesSpoken: Dispatch<SetStateAction<SEOSegmentationFilterInput['languages']>>;
}

const ChildCareFilters = ({
  hourlyRate,
  setHourlyRate,
  numberOfChildren,
  setNumberOfChildren,
  childCareAgeGroupsList,
  setChildCareAgeGroupsList,
  childCareProfessionalSkillsList,
  setChildCareProfessionalSkillsList,
  setPreferencesObject,
  languagesSpoken,
  setLanguagesSpoken,
}: ChildCareFiltersProp) => {
  return (
    <>
      <PayRate hourlyRate={hourlyRate} setHourlyRate={setHourlyRate} />
      <NumberOfChildren
        numberOfChildren={numberOfChildren}
        setNumberOfChildren={setNumberOfChildren}
      />
      <ChildAgeRanges
        childCareAgeGroupsList={childCareAgeGroupsList}
        setChildCareAgeGroupsList={setChildCareAgeGroupsList}
      />
      <ProfessionalSkills
        childCareProfessionalSkillsList={childCareProfessionalSkillsList}
        setChildCareProfessionalSkillsList={setChildCareProfessionalSkillsList}
      />
      <Preferences setPreferencesObject={setPreferencesObject} />
      <LanguagesSpoken languagesSpoken={languagesSpoken} setLanguagesSpoken={setLanguagesSpoken} />
    </>
  );
};

export { ChildCareFilters };
